import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useInvoices() {
  const [invoices, setInvoices] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.coaches.invoices.index)
      .then((response) => {
        setInvoices(response.data.data);
      });
  }, []);

  return invoices;
}
